import { AnyAction, combineReducers } from "redux";
import AccountAnalyze, { AccountSum, Movement } from "../app/AccountAnalyze";
import { AppDispatch, ThunkResult } from "./index";

export const calculateReport = (db: PouchDB.Database): ThunkResult<void> => async (dispatch: AppDispatch) => {
  const result = await AccountAnalyze.process(db);
  dispatch({ type: "UPDATE_REPORT_SUMMARY", payload: result });
};

export const fetchAccountData = (db: PouchDB.Database, accountNo: number): ThunkResult<void> => async (dispatch: AppDispatch, getState) => {
  if (getState().report.detail.accountNo !== accountNo) {
    const result = await AccountAnalyze.fetch(db, accountNo);
    dispatch({ type: "UPDATE_ACCOUNT_DATA", accountNo, payload: result });
  }
};

const summary = (state: AccountSum[] = [], action: AnyAction): AccountSum[] => {
  switch (action.type) {
    case "UPDATE_REPORT_SUMMARY":
      return action.payload;
    default:
      return state;
  }
};

const detailDefault = { accountNo: undefined as (number | undefined), result: [] as Movement[] };

const detail = (state = detailDefault, action: AnyAction) => {
  switch (action.type) {
    case "UPDATE_ACCOUNT_DATA":
      return { accountNo: action.accountNo as number, result: action.payload as Movement[] };
    case "CLEAR_ACCOUNT_DATA":
      return detailDefault;
  }
  return state;
};

export default combineReducers({
  summary,
  detail
});



// WEBPACK FOOTER //
// ./src/redux/report.ts